export default (prop, val, obj) => {
  const result = {}
  for (const p in obj) {
    result[p] = obj[p]
  }
  result[prop] = val
  return result
}
